import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_OperationTimeDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: 'h' | 'min';
    value?: number;
    position: e_Positions;
};

export type t_OperationTimeDataset = {
    dataPoints: t_OperationTimeDataPoint[];
};

export enum e_Positions {
    Connection_Upper_Undercarriage,
    Engine_Uppercarriage,
    Boom_Stick_Cylinder,
    Tool,
}

export var initOperationTimeDataset: t_OperationTimeDataset = {
    dataPoints: [
        {
            generalName: 'DATANAMES.TIMES.MACHINE',
            dataName: {
                name: 'MachineOperatingTime',
            },
            unit: 'h',
            position: e_Positions.Engine_Uppercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.T15',
            dataName: {
                name: 'MachineT15Time',
            },
            unit: 'h',
            position: e_Positions.Engine_Uppercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.ENGINE_RUNNING',
            dataName: {
                name: 'MachineEngineRunningTime',
            },
            unit: 'h',
            position: e_Positions.Engine_Uppercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.BOOM',
            dataName: {
                name: 'OperatingTimeBoom',
            },
            unit: 'h',
            position: e_Positions.Boom_Stick_Cylinder
        },
        {
            generalName: 'DATANAMES.TIMES.STICK',
            dataName: {
                name: 'OperatingTimeStick',
            },
            unit: 'h',
            position: e_Positions.Boom_Stick_Cylinder
        },
        {
            generalName: 'DATANAMES.TIMES.TOOL_SLEW',
            dataName: {
                name: 'OperatingTimeToolSlew',
            },
            unit: 'h',
            position: e_Positions.Tool
        },
        {
            generalName: 'DATANAMES.TIMES.TOOL_OPEN_CLOSE',
            dataName: {
                name: 'OperatingTimeToolOpenClose',
            },
            unit: 'h',
            position: e_Positions.Tool
        },
        {
            generalName: 'DATANAMES.TIMES.DRIVE',
            dataName: {
                name: 'OperatingTimeDrive',
            },
            unit: 'h',
            position: e_Positions.Connection_Upper_Undercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.STEERING',
            dataName: {
                name: 'OperatingTimeSteering',
            },
            unit: 'h',
            position: e_Positions.Connection_Upper_Undercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.SLEWING',
            dataName: {
                name: 'OperatingTimeSlewing',
            },
            unit: 'h',
            position: e_Positions.Connection_Upper_Undercarriage
        },
    ],
};
